import { Virtuoso } from 'react-virtuoso'

export function VirtualizedTable(props: any) {
  return <Virtuoso {...props} />
}
